import React, { useRef, useCallback } from 'react';
export const ModalContext = React.createContext(undefined);
export const ModalContextProvider = ({ children }) => {
    const activeModals = useRef([]);
    const registerModal = useCallback((modalId) => {
        activeModals.current.push(modalId);
    }, []);
    const unregisterModal = useCallback((modalId) => {
        activeModals.current = activeModals.current.filter((id) => id !== modalId);
    }, []);
    return (React.createElement(ModalContext.Provider, { value: {
            activeModals,
            registerModal,
            unregisterModal
        } }, children));
};
//# sourceMappingURL=ModalContext.js.map